import { render, staticRenderFns } from "./ProvidersReportingData.vue?vue&type=template&id=3f4ea744"
import script from "./ProvidersReportingData.vue?vue&type=script&lang=js"
export * from "./ProvidersReportingData.vue?vue&type=script&lang=js"
import style0 from "./ProvidersReportingData.vue?vue&type=style&index=0&id=3f4ea744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports